import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import highResDesktopImageWebp from './images/college-savings-plans-hero-desktop.webp';
import highResMobileImageWebp from './images/college-savings-plans-hero-mobile.webp';
// low res images
import { lowResImageDesktop, lowResImageMobile } from './lowResImages';
// styles
import { HeroSectionStyled } from './styles';

export default () => {
  return (
    <HeroSectionStyled
      sectionId='college-savings-plans-page-flexible-hero'
      moduleName='hero-module'
      productName='College Savings Plans'
      headingText={<>Planning for a <WidowBlock>brighter future.</WidowBlock></>}
      descriptionText={<>No matter the school your kids end up attending, give them a financial head start by putting together a savings plan that will help cover the costs and open opportunities.</>}
      ctaPrimary={{
        linkUrl: '/find-a-financial-advisor/',
        buttonText: 'Start planning',
        ariaLabel: 'Start planning with a financial professional',
        children: '',
      }}
      backgroundImageAriaLabel='A young girl looking at a globe.'
      backgroundImageDesktop={highResDesktopImageWebp.toString()}
      backgroundImageMobile={highResMobileImageWebp.toString()}
      backgroundImageDesktopLowRes={lowResImageDesktop}
      backgroundImageMobileLowRes={lowResImageMobile}
      backgroundVariant='lightB'
      themeType='lightTheme'
    />
  );};
